<template>
  <div>
    <b-form-row class="align-items-center px-50 justify-content-between">
      <h4>قطاعات المشروع</h4>
    </b-form-row>
    <b-form-row>
      <b-col cols="12">
        <hr />
      </b-col>
      <b-col cols="12">
        <b-list-group class="rounded border">
          <b-list-group-item class="bg-secondary bg-lighten-3">
            <b-form-row class="text-white">
              <b-col> قطاع المشروع</b-col>
              <b-col> الميزانية المرصودة للأنشطة </b-col>
              <b-col> عدد المستفيدين </b-col>
              <b-col> عدد النساء المستفيدات </b-col>
              <b-col> عدد ذوي الاحتياجات الخاصة المستفيدين </b-col>
              <b-col> الفئة المستهدفة </b-col>
              <b-col> </b-col>
            </b-form-row>
          </b-list-group-item>
          <template v-if="loadingRecords">
            <div class="text-center text-info my-2">
              <b-spinner class="align-middle mx-2"></b-spinner>
              <strong>جاري التحميل...</strong>
            </div>
          </template>
          <template v-else>
            <template v-if="records.length === 0 && !isAdding">
              <span class="text-center my-1" style="opacity: 0.7"
                >لا يوجد سجلات حتى الآن</span
              >
            </template>
            <b-list-group-item
              v-for="(department, index) in records"
              :key="index"
            >
              <validation-observer
                v-if="isEdit === department.id"
                ref="EditFormValidation"
              >
                <b-form @submit.prevent="onSubmit(index)">
                  <b-form-row>
                    <b-col>
                      <form-select
                        label="قطاع المشروع"
                        rules="required"
                        v-model="toAdd.division_id"
                        id="eproject-dep"
                        ep="v2/selects/divisions"
                        :getOptionLabel="(x) => x.name"
                        :reduce="(x) => x.id"
                      />
                    </b-col>
                    <b-col>
                      <form-currency
                        label="الميزانية المرصودة للأنشطة"
                        id="expected_budget"
                        v-model="toAdd.expected_budget"
                        rules="required"
                      />
                    </b-col>
                    <b-col>
                      <form-cleave
                        label="عدد المستفيدين"
                        rules="required"
                        id="id-num"
                        v-model="toAdd.ben_number"
                        isNumber
                      />
                    </b-col>
                    <b-col>
                      <form-cleave
                        label="عدد النساء المستفيدات"
                        rules="required"
                        id="id-num"
                        v-model="toAdd.ben_women_percentage"
                        isNumber
                      />
                    </b-col>
                    <b-col>
                      <form-cleave
                        label="عدد ذوي الاحتياجات الخاصة المستفيدين"
                        rules="required"
                        id="id-num"
                        v-model="toAdd.ben_disabled_percentage"
                        isNumber
                      />
                    </b-col>
                    <b-col>
                      <form-select
                        label="الفئة المستهدفة"
                        id="age-categories"
                        ep="v2/selects/age-categories"
                        v-model="toAdd.category_id"
                        :getOptionLabel="(x) => x.name_ar"
                        :reduce="(x) => x.id"
                        rules="required"
                      />
                    </b-col>
                    <b-col
                      class="justify-content-end d-flex pt-50 align-items-center"
                    >
                      <b-button
                        @click="isEdit = null"
                        variant="flat-secondary  "
                        class="mx-50"
                      >
                        إلغاء
                      </b-button>
                      <loader-btn
                        :loading="working"
                        variant="primary"
                        type="submit"
                      >
                      </loader-btn>
                    </b-col>
                  </b-form-row>
                </b-form>
              </validation-observer>
              <b-form-row v-else class="align-items-center">
                <b-col> {{ department.division.name }}</b-col>
                <b-col>
                  {{
                    new Intl.NumberFormat().format(department.expected_budget)
                  }}
                </b-col>
                <b-col> {{ department.ben_number }} </b-col>
                <b-col> {{ department.ben_women_percentage }} </b-col>
                <b-col> {{ department.ben_disabled_percentage }} </b-col>
                <b-col> {{ department.category.name_ar }} </b-col>

                <b-col class="justify-content-end d-flex">
                  <b-button
                    @click="editDepartment(department)"
                    variant="flat-primary"
                    class="btn-icon rounded-circle"
                  >
                    <feather-icon icon="EditIcon" />
                  </b-button>
                  <b-button
                    @click="onDeleteClicked(department.id)"
                    variant="flat-danger"
                    class="btn-icon rounded-circle"
                  >
                    <feather-icon icon="Trash2Icon" />
                  </b-button>
                </b-col>
              </b-form-row>
            </b-list-group-item>
            <b-list-group-item v-if="isAdding">
              <validation-observer ref="FormValidation">
                <b-form @submit.prevent="onSubmit">
                  <b-form-row>
                    <b-col>
                      <form-select
                        label="قطاع المشروع"
                        rules="required"
                        v-model="toAdd.division_id"
                        id="eproject-dep"
                        ep="v2/selects/divisions"
                        :getOptionLabel="(x) => x.name"
                        :reduce="(x) => x.id"
                      />
                    </b-col>
                    <b-col>
                      <form-currency
                        label="الميزانية المرصودة للأنشطة"
                        id="budget"
                        v-model="toAdd.expected_budget"
                        rules="required"
                      />
                    </b-col>

                    <b-col>
                      <form-cleave
                        label="عدد المستفيدين"
                        rules="required"
                        id="id-num"
                        v-model="toAdd.ben_number"
                        isNumber
                      />
                    </b-col>
                    <b-col>
                      <form-cleave
                        label="عدد النساء المستفيدات"
                        rules="required"
                        id="id-num"
                        v-model="toAdd.ben_women_percentage"
                        isNumber
                      />
                    </b-col>
                    <b-col>
                      <form-cleave
                        label="عدد ذوي الاحتياجات الخاصة المستفيدين"
                        rules="required"
                        id="id-num"
                        v-model="toAdd.ben_disabled_percentage"
                        isNumber
                      />
                    </b-col>

                    <b-col>
                      <form-select
                        label="الفئة المستهدفة"
                        id="age-categories"
                        ep="v2/selects/age-categories"
                        v-model="toAdd.category_id"
                        :getOptionLabel="(x) => x.name_ar"
                        :reduce="(x) => x.id"
                        rules="required"
                      />
                    </b-col>
                    <b-col
                      class="justify-content-end d-flex pt-50 align-items-center"
                    >
                      <b-button
                        @click="isAdding = false"
                        variant="flat-secondary  "
                        class="mx-50"
                      >
                        إلغاء
                      </b-button>
                      <loader-btn
                        :loading="working"
                        variant="primary"
                        type="submit"
                      >
                      </loader-btn>
                    </b-col>
                  </b-form-row>
                </b-form>
              </validation-observer>
            </b-list-group-item>
          </template>
        </b-list-group>
        <b-form-row class="px-50 mt-1 d-flex justify-content-end">
          <b-button @click="onNewClicked" variant="success">
            <feather-icon icon="PlusIcon" />
            <span> إضافة </span>
          </b-button>
        </b-form-row>
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
import {
  BButton,
  BFormGroup,
  BSpinner,
  BListGroup,
  BListGroupItem,
  BFormRow,
  BCol,
  BForm,
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import FormInput from "@/components/form-input";
import FormSelect from "@/components/form-select";
import FormDatepicker from "@/components/form-datepicker";
import FormCleave from "@/components/FormCleave.vue";
import LoaderBtn from "@/components/loader-btn.vue";
import tableEditMixin from "../mixins/TableEditMixin";
import FormCurrency from "@/components/FormCurrency.vue";

export default {
  mixins: [tableEditMixin],
  components: {
    FormInput,
    BButton,
    BFormGroup,
    BSpinner,
    BListGroup,
    BListGroupItem,
    BFormRow,
    BCol,
    LoaderBtn,
    BForm,
    ValidationObserver,
    FormSelect,
    FormDatepicker,
    FormCleave,
    Cleave,
    FormCurrency,
  },

  data() {
    return {};
  },
  computed: {
    fetchEndpoint() {
      return `v2/co-op/project/${this.$route.params.id}/divisions`;
    },
    operationsEndpoint() {
      return `v2/co-op/project/divisions`;
    },
  },
  methods: {
    editDepartment(dep) {
      var mapped = { ...dep };
      mapped.division_id = dep.division.id;
      mapped.category_id = dep.category.id;
      delete mapped.division;
      delete mapped.category;
      this.onEditClicked(mapped);
    },
  },
};
</script>
